import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const DRAMA_LOGO = "https://skyagent-artifacts.skywork.ai/router/agent/2026-05-27/prod_agent_bf7a3757-9d75-4ece-87fa-88ca52e3f043/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20260129225514_30_43_13adae7bab5140e5ac2ef30616ab0049.jpg";

const features = [
  { label: "Local Actors & Teams", sub: "本地演员与制作团队", icon: "🎭" },
  { label: "3-Language Production", sub: "马来语·英语·中文", icon: "🌏" },
  { label: "Mobile-First Format", sub: "移动端优先内容形态", icon: "📱" },
  { label: "High Retention Rates", sub: "高留存·强用户粘性", icon: "🔗" },
  { label: "Data-Driven Stories", sub: "数据驱动内容迭代", icon: "📊" },
  { label: "Rapid IP Creation", sub: "快速IP孵化能力", icon: "⚡" },
];

const MireDrama = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.15 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="drama" ref={ref} style={{
      padding: "100px 40px",
      background: "linear-gradient(180deg, #080808 0%, rgba(255,28,53,0.04) 50%, #080808 100%)",
    }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <motion.div initial={{ opacity: 0, y: 24 }} animate={visible ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.7 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
            <div style={{ width: 36, height: 2, background: "#FF1C35" }} />
            <span style={{ color: "#FF1C35", fontSize: 12, fontWeight: 700, letterSpacing: 3 }}>FLAGSHIP PRODUCT · 核心产品</span>
          </div>
        </motion.div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 60, alignItems: "center" }} className="drama-grid">
          {/* Left: Info */}
          <motion.div initial={{ opacity: 0, x: -30 }} animate={visible ? { opacity: 1, x: 0 } : {}} transition={{ delay: 0.2, duration: 0.7 }}>
            <h2 style={{ fontSize: "clamp(28px, 4vw, 48px)", fontWeight: 900, lineHeight: 1.1, margin: "0 0 20px" }}>
              Malaysia's <span style={{ color: "#FF1C35" }}>#1</span> Local<br />Short Drama Platform
            </h2>
            <p style={{ fontSize: 15, color: "rgba(255,255,255,0.55)", lineHeight: 1.8, marginBottom: 12 }}>
              MIRE DRAMA is Malaysia's largest localized short drama platform — bridging authentic storytelling with next-gen AI production.
            </p>
            <p style={{ fontSize: 13, color: "rgba(255,255,255,0.3)", lineHeight: 1.8, marginBottom: 36 }}>
              短剧是流量入口，也是用户信任的起点。本地故事，真实共鸣。
            </p>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 36 }}>
              {features.map((f, i) => (
                <motion.div key={f.label}
                  initial={{ opacity: 0, y: 12 }} animate={visible ? { opacity: 1, y: 0 } : {}}
                  transition={{ delay: 0.3 + i * 0.07, duration: 0.5 }}
                  style={{
                    display: "flex", alignItems: "flex-start", gap: 10,
                    padding: "14px 16px", borderRadius: 10,
                    background: "rgba(255,255,255,0.03)",
                    border: "1px solid rgba(255,255,255,0.06)",
                  }}
                >
                  <span style={{ fontSize: 20 }}>{f.icon}</span>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "#fff" }}>{f.label}</div>
                    <div style={{ fontSize: 11, color: "rgba(255,255,255,0.35)" }}>{f.sub}</div>
                  </div>
                </motion.div>
              ))}
            </div>

            <a href="https://miredrama.com" target="_blank" rel="noopener noreferrer"
              style={{
                display: "inline-flex", alignItems: "center", gap: 8,
                padding: "13px 28px", background: "#FF1C35",
                color: "#fff", borderRadius: 8, textDecoration: "none",
                fontSize: 14, fontWeight: 700, letterSpacing: 0.5,
                boxShadow: "0 0 24px rgba(255,28,53,0.3)",
                transition: "opacity 0.2s",
              }}
              onMouseEnter={e => (e.currentTarget.style.opacity = "0.85")}
              onMouseLeave={e => (e.currentTarget.style.opacity = "1")}
            >
              Visit MIRE DRAMA Platform →
            </a>
          </motion.div>

          {/* Right: Logo + Glow */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={visible ? { opacity: 1, scale: 1 } : {}}
            transition={{ delay: 0.3, duration: 0.8 }}
            style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              position: "relative",
            }}
          >
            <div style={{
              position: "absolute", width: 300, height: 300, borderRadius: "50%",
              background: "radial-gradient(circle, rgba(255,28,53,0.15) 0%, transparent 70%)",
              filter: "blur(40px)",
            }} />
            <div style={{
              width: 320, height: 320, borderRadius: 24,
              background: "rgba(255,255,255,0.04)",
              border: "1px solid rgba(255,255,255,0.1)",
              display: "flex", alignItems: "center", justifyContent: "center",
              position: "relative", overflow: "hidden",
              boxShadow: "0 20px 60px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,28,53,0.1)",
            }}>
              <img
                src={DRAMA_LOGO}
                alt="MIRE DRAMA"
                style={{ width: "75%", objectFit: "contain" }}
              />
            </div>
          </motion.div>
        </div>
      </div>
      <style>{`
        @media (max-width: 768px) { .drama-grid { grid-template-columns: 1fr !important; gap: 40px !important; } }
      `}</style>
    </section>
  );
};

export default MireDrama;
